import React from "react";
import { Link } from "react-router-dom";

function Breadcrump({ title, middle = "" }) {
  return (
    <section className="breadcrumb-section">
      <div className="breadcrumb-overlay">
        <div className="container">
          <div className="breadcrumb-content text-center">
            
            <h2 className="breadcrumb-title">{title}</h2>

            <div className="breadcrumb-list">
              <Link to="/" className="breadcrumb-link">
                Home
              </Link>

              {middle && (
                <>
                  <span className="breadcrumb-separator">/</span>
                  <Link to="/" className="breadcrumb-link">
                    {middle}
                  </Link>
                </>
              )}

              <span className="breadcrumb-separator">/</span>

              <span className="breadcrumb-current">
                {title}
              </span>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default Breadcrump;